import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { translate } from 'core/utils';
import { Loader, BaasicInput, BaasicDropzone, BaasicDropdown } from 'core/components';

const UploadDocumentTemplate = ({
	t,
	uploadDocumentViewStore: {
		loading,
		form,
		modalParams,
		saveFile,
		showShipmentDetails,
		existingDocumentDescription,
		documentTypeDropdownStore,
		carrierServiceDropdownStore,
		carrierDropdownStore,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.UPLOADDOCUMENTMODAL.TITLE')}</h3>
				</div>
				<div className="ReactModal__body">
					<div className="col col-sml-12 col-lrg-12 spc--bottom--sml">
						<BaasicDropdown dropdownStore={documentTypeDropdownStore} />
						{existingDocumentDescription && (
							<p className="type--tny type--color--opaque">
								{t('FULFILLMENTORDER.UPLOADDOCUMENTMODAL.ALREADYUPLOADED')} {existingDocumentDescription}
							</p>
						)}
					</div>

					{showShipmentDetails && (
						<React.Fragment>
							<div className="col col-sml-12 col-lrg-12">
								<BaasicInput field={form.$('trackingNumber')} />
							</div>
							<div className="col col-sml-12 col-lrg-12 spc--bottom--sml">
								<BaasicDropdown dropdownStore={carrierServiceDropdownStore} />
							</div>
							<div className="col col-sml-12 col-lrg-12 spc--bottom--sml">
								<BaasicDropdown dropdownStore={carrierDropdownStore} />
							</div>
							<div className="col col-sml-12 col-lrg-12 spc--bottom--sml">
								<BaasicInput field={form.$('shippingCost')} />
							</div>
						</React.Fragment>
					)}

					<div className="col col-sml-12 col-lrg-12 spc--bottom--sml">
						<label>{t('FULFILLMENTORDER.UPLOADDOCUMENTMODAL.FILE')}</label>
						<div>
							<BaasicDropzone acceptFiles={'.pdf'} onFilesDrop={saveFile} placeholder={form.$('file').value.fileName} />
						</div>
					</div>
				</div>
				{form.error && (
					<div>
						<p className="type--color--warning">{translate(form.error)}</p>
					</div>
				)}
				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--right--sml spc--bottom--sml" type="submit">
						{t('SAVE')}
					</button>
					<button className="btn btn--med btn--secondary spc--bottom--sml" type="button" onClick={modalParams.close}>
						{t('BACK')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(UploadDocumentTemplate);
